import React from 'react';
import { format } from 'date-fns';
import { dateKey, weekDays } from '../../timesheetDerive';
import { formatHoursShort } from '../../../../utils/timesheetTime';
import './day-picker.scss';

interface DayPickerProps {
  weekEndingDate: string;
  selectedDate: string;
  onSelect: (date: string) => void;
  /** Hours per yyyy-MM-dd, for the figure under each chip. */
  totals: Map<string, number>;
  standardHours: number;
}

/**
 * Mon..Sun chips for the Day view, each with its hours against the standard
 * day: met (green), short (amber), or none.
 */
const DayPicker: React.FC<DayPickerProps> = ({ weekEndingDate, selectedDate, onSelect, totals, standardHours }) => {
  const todayKey = dateKey(new Date());
  return (
    <div className="day-picker" role="tablist" aria-label="Days">
      {weekDays(weekEndingDate).map((day) => {
        const key = dateKey(day);
        const hours = totals.get(key) ?? 0;
        const tone = hours === 0 ? 'none' : hours >= standardHours ? 'met' : 'short';
        return (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={key === selectedDate}
            className={`day-chip ${key === selectedDate ? 'is-selected' : ''} ${key === todayKey ? 'is-today' : ''} day-chip--${tone}`}
            onClick={() => onSelect(key)}
          >
            <span className="day-chip__when">
              <span className="day-chip__name">{format(day, 'EEE')}</span>
              <span className="day-chip__date">{format(day, 'd')}</span>
            </span>
            <span className="day-chip__hours">{hours > 0 ? formatHoursShort(hours) : '–'}</span>
          </button>
        );
      })}
    </div>
  );
};

export default DayPicker;
